
import enCommon from './en/common';
import koCommon from './ko/common';
import enDashboard from './en/dashboard';
import koDashboard from './ko/dashboard';
import enAuth from './en/auth';
import koAuth from './ko/auth';

export default {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    auth: enAuth,
  },
  ko: {
    common: koCommon,
    dashboard: koDashboard,
    auth: koAuth,
  },
};
